import useAPI from '@/hooks/useAPI';
import ProgramQualificationRepository from '@/repositories/ProgramQualificationRepository';
import { PaginationParams } from '@/types/pagination';

interface ProgramQualificationParams extends PaginationParams {
  person_id: string;
}

export const useProgramQualifications = ({ person_id, page }: ProgramQualificationParams) => {
  const programQualificationRepository = ProgramQualificationRepository();

  return useAPI({
    queryKey: ['programQualificationsList', person_id, page],
    queryFn: async () => {
      return await programQualificationRepository.list({ person_id, page });
    }
  });
};

export default useProgramQualifications;
